<ng-template #template>
  <div [class]="question.cssClasses.hint">
    <div *ngIf="model.showHintPrefix" [class]="question.cssClasses.hintPrefix">
        <span>{{ model.hintStringPrefix }}</span>
    </div>
    <div [class]="question.cssClasses.hintSuffixWrapper">
        <div *ngIf="model.showHintString" [class]="question.cssClasses.hintSuffix">
            <span style="visibility: hidden">{{ model.inputStringRendered }}</span>
            <span>{{ model.hintStringSuffix }}</span>
        </div>
    <input
      type="text"
      autocomplete="off"
      [(ngModel)]="model.inputStringRendered"
      [attr.id]="question.getInputId()"
      [class]="question.cssClasses.filterStringInput"
      [attr.inputmode]="model.inputMode"
      [attr.role]="model.filterStringEnabled ? question.ariaRole : null"
      [attr.readonly]="model.filterReadOnly ? true : null"
      [attr.disabled]="question.isDisabledAttr ? true : null"
      [attr.size]="!model.inputStringRendered ? 1 : null"
      [attr.aria-label]="question.a11y_input_ariaLabel"
      [attr.aria-labelledby]="question.a11y_input_ariaLabelledBy"
      [attr.aria-describedby]="question.a11y_input_ariaDescribedBy"
      [attr.aria-controls]="model.listElementId"
      [attr.aria-expanded]="question.ariaExpanded"
      [attr.aria-activedescendant]="model.ariaActivedescendant"
      [attr.placeholder]="model.filterStringPlaceholder"
      (keydown)="model.inputKeyHandler($event)"
      (blur)="question.onBlur($event)"
      (focus)="question.onFocus($event)"
    />
    </div>
  </div>
</ng-template>
